import helper from '../../utils/helper'
import baseApi from '../../api/common/baseApi.js'

const quoteService = {
	/**
	 * Get quote information
	 * @param {*} formData
	 * @param {*} optionData
	 * @param {*} culture - this.$locale
	 * @returns
	 */
	async getQuoteAsync(formData, optionData, culture) {
		
		let families = this._getFamilyDetails(formData, optionData.nationalities)
		if (!formData.policyDetails.policyHolderInsured) {
			families = families.filter((v) => !v.isAPolicyHolder)
		}

		let policyResidence = this._getCountryDetail(
			formData.policyHolder.details.residenceCountryId,
			optionData.residenceCountries,
		)
		let currency = optionData.currencies.find((c) => c.value == parseInt(formData.policyDetails.currencyId))
		let quoteRequest = {
			formDataId: formData.id,
			quoteRequest: {
				culture,
				quoteRef: '',
				selectedDate: formData.policyDetails.policyStartDate,
				countryOfResidence: policyResidence,
				currency: {
					currencyID: currency.value,
					currencyName: currency.text,
					currencySymbol: currency.field1,
					currencyCode: currency.field2,
				},
				insuranceType: 1,
				insureds: families,
			},
		}

		try {
			let quote = await baseApi.post('api/quote', quoteRequest)
			// console.log(quote)
			this.validPackageValue(quote)
			
			return quote
		} catch (e) {
			console.error('Quote: ', e)
			throw e
		}
	},

	async updateQuoteAsync(quoteUpdated) {
		try {
			var resp = await baseApi.post('api/updateQuote', quoteUpdated)
			return resp.quote
		} catch (e) {
			console.error('update quote error: ', e)
			throw e
		}
	},

	validPackageValue(quote) {
		quote.products.forEach((product) => {
			product.areasOfCover = product.areasOfCover.filter(function (area) {
				var isValid = false
				area.levelsOfCover.forEach((l) => {
					if (l.premiumsAsPerPaymentFrequency.premiumBreakdownByPaymentFrequency.length > 0) {
						isValid = true
					}
				})
				return isValid
			})
		})
	},

	async getUnderwritingTypesAsync(formData, optionData, quote, culture = 'en') {
		// list family of insured
		// get family in formData
		let families = this._getFamilyDetails(formData, optionData.nationalities, true)

		// get age family
		let insuredAges = families.map((f) => f.age)

		let req = {
			culture: culture,
			insuredAges: insuredAges,
			products: [
				{
					productId: formData.product.productId,
					productName: quote.products.find((p) => p.productID == formData.product.productId).productName,
				},
			],
			selectedDate: formData.policyDetails.policyStartDate,
		}

		try {
			return await baseApi.post('api/underwritingTypes', req)
		} catch (error) {
			console.error('UnderwritingTypes: ', error)
		}
	},

	getTotalPrice(summary) {
		let premiumFrequencies = summary.levelOfCover.premiumsAsPerPaymentFrequency.premiumBreakdownByPaymentFrequency
		// total premium info
		var premiumResult = {
			paymentFrequencyId: -1,
			premiumWithoutTax: 0,
			totalTax: 0,
			totalPremium: 0,
			paymentFrequencyName: '',
			paymentFrequencyNameTranslation: '',
			frequencyAmount: 0,
			basePremium: 0,
			firstInvoice: 0,
			secondInvoice: 0,
			totalPaymentFrequencyAmount: 0,
			vat : 0,
			annualisedVat: 0,
			paymentFrequencyDividedBy : 0,
			totalPremiumWithTaxAndVat: 0,
			taxDividedByPaymentFrequencyAmount: 0,
			isVatTheOnlyTaxApplied: true,
		}

		if (!premiumFrequencies || premiumFrequencies.length == 0) {
			return premiumResult
		}

		// Get by frequencyId
		var premiumFrequency = premiumFrequencies.find(
			(v) => v.paymentFrequencyID == summary.frequencySelected.paymentFrequencyID,
		)

		premiumResult.paymentFrequencyId = premiumFrequency.paymentFrequencyID
		premiumResult.premiumWithoutTax = premiumFrequency.totalPremiumWithoutTax
		premiumResult.totalTax = premiumFrequency.totalTax
		premiumResult.totalPremium = premiumFrequency.totalPremiumWithTax
		premiumResult.paymentFrequencyName = premiumFrequency.paymentFrequencyName
		premiumResult.paymentFrequencyNameTranslation = summary.productSelected.paymentFrequencies.find(
			(v) => v.paymentFrequencyID == premiumFrequency.paymentFrequencyID,
		).paymentFrequencyNameTranslation
		premiumResult.frequencyAmount = premiumFrequency.premiumWithTax
		premiumResult.basePremium = premiumFrequency.basePremium
		premiumResult.totalPaymentFrequencyAmount = premiumFrequency.totalPaymentFrequencyAmount
		premiumResult.paymentFrequencyDividedBy = premiumFrequency.paymentFrequencyDivideBy
		premiumResult.totalPremiumWithTaxAndVat = premiumFrequency.totalPremiumWithTaxAndVat
		premiumResult.taxDividedByPaymentFrequencyAmount = premiumFrequency.paymentFrequencyEx.taxDividedByPaymentFrequencyAmount

		let vatPresent = false
		let vatTaxCount = 0

		premiumFrequency.taxesApplied.forEach((tax, index, array) => {
			if (tax.key.taxTypeShortName.toLowerCase() === 'vat') {
				premiumResult.vat += tax.value
				vatPresent = true
				vatTaxCount = vatTaxCount + 1
			} else {
				premiumResult.isVatTheOnlyTaxApplied = false
			}
		})

		if (vatTaxCount > 0) {
			premiumResult.isVatTheOnlyTaxApplied = premiumFrequency.taxesApplied.length == vatTaxCount
		}

		if (vatPresent) {
			premiumResult.annualisedVat = premiumResult.vat
			premiumResult.vat = (premiumFrequency.paymentFrequencyDivideBy > 0) ? premiumResult.vat / premiumFrequency.paymentFrequencyDivideBy : premiumResult.vat

			premiumResult.annualisedVat = (Math.round(premiumResult.annualisedVat * 100) / 100).toFixed(2)
			premiumResult.vat = (Math.round(premiumResult.vat * 100) / 100).toFixed(2)
		}

		if (premiumFrequency.invoices && premiumFrequency.invoices.length) {
			try {
				premiumResult.firstInvoice = premiumFrequency.invoices[0].amount
			} catch (e) {
				console.error(e)
			}

			try {
				if (premiumFrequency.invoices.length > 1) {
					premiumResult.secondInvoice = premiumFrequency.invoices[1].amount
				}
			} catch (e) {
				console.error(e)
			}
		}

		return premiumResult
	},

	_getFamilyDetails(formData, nationalities, includePolicyHolder = true) {
		let result = []
		// get policy holder info
		if (includePolicyHolder) {
			let policyInfo = formData.policyHolder.details
			result.push({
				age: helper.getAge(new Date(policyInfo.dateOfBirth)),
				insuredID: '',
				isAPolicyHolder: true,
				nationality: this._getCountryDetail(policyInfo.nationalityCountryId, nationalities),
			})
		}

		// family
		formData.familyMembers.forEach((f) => {
			result.push({
				age: helper.getAge(new Date(f.details.dateOfBirth)),
				insuredID: '',
				isAPolicyHolder: false,
				nationality: this._getCountryDetail(f.details.nationalityCountryId, nationalities),
			})
		})

		return result
	},

	_getCountryDetail(selectedId, country) {
		let countryRes = country.find((n) => n.value == selectedId)
		return {
			countryID: countryRes.value,
			countryName: countryRes.text,
			countryCode: countryRes.field1,
			regionID: parseInt(countryRes.field3),
		}
	},
}

export default quoteService
